import '../assets/fonts/fonts.css';
import { NavLink } from 'react-router-dom';

export default function Header() {
  return (
    <div>
      <div className="absolute w-auto top-[2.6vw] left-[6vw]  z-[9999]">
        <div className="relative inline-flex items-end gap-2"> {/* 新增间隙 */}
          <span className="text-[#fff] text-[2vw] font-['TsangerTQXKW']">天籁瓷鉴</span>
          <span className="text-[1.2vw] text-[#fff] transform translate-x-[0.2vw] -translate-y-[0.4vw]">Tianlai.China</span>
        </div>
      </div>
      <div className="absolute w-auto top-[2.8vw] right-[8vw]  z-[9999]">
        <nav className="flex justify-end space-x-[5.7vw] ml-auto">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-[1.5vw] tracking-wider font-normal transition-transform hover:scale-110 ${isActive ? "text-[#ff0000]" : "text-[#fff]"}`
            }
          >
            {({ isActive }) => (
              <div className="relative inline-flex items-end">
                <span className={`${isActive ? "border-b-[0.4vh]" : ""}`}>溯源</span>
                <span className="ml-2 text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                  Traceability
                </span>
              </div>
            )}
          </NavLink>
          <NavLink
            to="/appreciation"
            className={({ isActive }) =>
              `text-[1.5vw] tracking-wider font-normal transition-transform hover:scale-110 ${isActive ? "text-[#ff0000]" : "text-[#fff]"}`
            }
          >
            {({ isActive }) => (
              <div className="relative inline-flex items-end">
                <span className={`${isActive ? "border-b-[0.4vh]" : ""}`}>鉴析</span>
                <span className="ml-2 text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                  Appreciation
                </span>
              </div>
            )}
          </NavLink>
          <NavLink
            to="/exploration"
            className={({ isActive }) =>
              `text-[1.5vw] tracking-wider font-normal transition-transform hover:scale-110 ${isActive ? "text-[#ff0000]" : "text-[#fff]"}`
            }
          >
            {({ isActive }) => (
              <div className="relative inline-flex items-end">
                <span className={`${isActive ? "border-b-[0.4vh]" : ""}`}>探微</span>
                <span className="ml-2 text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                  Exploration
                </span>
              </div>
            )}
          </NavLink>
          <NavLink
            to="/rhymetasting"
            className={({ isActive }) =>
              `text-[1.5vw] tracking-wider font-normal transition-transform hover:scale-110 ${isActive ? "text-[#ff0000]" : "text-[#fff]"}`
            }
          >
            {({ isActive }) => (
              <div className="relative inline-flex items-end">
                <span className={`${isActive ? "border-b-[0.4vh]" : ""}`}>品韵</span>
                <span className="ml-2 text-[1vw] transform translate-x-[0.4vw] -translate-y-[0.2vw]">
                  Rhyme Tasting
                </span>
              </div>
            )}
          </NavLink>
        </nav>
      </div>
    </div>
  )
}